import jwt_decode from 'jwt-decode';

// Presentation guard only. Future API endpoints must use MotorCommissionViewer.
export function canViewMotorCommissions(token?: string): boolean {
  if (!token) return false;
  try {
    const claims = jwt_decode<{ AccountType?: string; CanViewReport?: string | boolean | number }>(token);
    const permission = String(claims.CanViewReport).toLowerCase();
    return claims.AccountType?.toUpperCase() === 'STAFF' && (permission === 'true' || permission === '1');
  } catch {
    return false;
  }
}
